<template>
    <div id="manifest-covered-legislations">
        <h6 class="manifest-covered-legislations__label mb-1">
            {{ $t('Component(ReceivedRequestSteps):requested-regulations') }}
            <span v-if="legislations.length" class="manifest-covered-legislations__count">
                · {{ legislations.length }}
            </span>
        </h6>
        <div class="d-flex flex-wrap">
            <BBadge
                v-for="legislation in legislations"
                :key="legislation.id"
                variant="light"
                class="manifest-regulation-badge border mr-50 mb-50 d-inline-flex align-items-center"
            >
                <span>{{ legislation.title }}</span>
                <InstructionInfoButton
                    v-if="legislationTranslationsLoaded && hasTranslations(legislation)"
                    class="ml-50"
                    :instruction="instruction(legislation)"
                    :title="title(legislation)"
                    button-class="btn-icon btn-sm"
                    icon-size="16"
                />
            </BBadge>
        </div>
    </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import InstructionInfoButton from '@core/components/common/instructions/InstructionInfoButton'
import legislationTranslations from '@core/mixins/legislation-translations'

export default {
    name: 'ManifestCoveredLegislations',
    components: { BBadge, InstructionInfoButton },
    mixins: [legislationTranslations],
    props: {
        legislations: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        title(legislation) {
            return this.getLegislationInfoTranslationHeader(legislation.id)
                || this.$t(`Component(IButton):legislation-title-${legislation.key}`)
        },
        instruction(legislation) {
            return this.getLegislationInfoTranslation(legislation.id)
                || this.$t(`Component(IButton):legislation-instruction-${legislation.key}`)
        },
        hasTranslations(legislation) {
            return this.hasLegislationInfoTranslation(legislation.id)
                || this.isTranslationSet(`Component(IButton):legislation-title-${legislation.key}`)
                || this.isTranslationSet(`Component(IButton):legislation-instruction-${legislation.key}`)
        },
        isTranslationSet(key) {
            const translation = this.$t(key)

            return translation !== key && translation.length > 0
        },
    },
}
</script>

<style scoped lang="scss">
.manifest-covered-legislations__label {
    color: #6e6b7b;
    font-size: 0.9375rem;
    font-weight: 500;
    line-height: 1.35;
}

.manifest-covered-legislations__count {
    color: #b9b9c3;
    font-weight: 400;
}

.manifest-regulation-badge {
    min-height: 2.375rem;
    padding: 0.55rem 0.75rem;
    color: #4b465c !important;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25;
    background-color: transparent !important;
    border-color: #ebe9f1 !important;
    border-radius: 0.375rem;
}
</style>
